<template>
  <div class="ws-slick-sort">

    <SlickList
      class="slick-list"
      lockAxis="y"
      helperClass="active-box"
      appendTo=".slick-list"
      :transitionDuration="100"
      :lockToContainerEdges="true"
      :distance="5"
      :lockOffset="['5px','5px']"
      tag="ul"
      @input="$_afterChange"
      :value="sortList"
    >
      <SlickItem
        class="slick-item"
        v-for="(item, index) in sortList"
        :index="index"
        :key="index"
        tag="li"
      >

        <slot
          :sortIndex="index"
          :sortItem="item"
        ></slot>
      </SlickItem>
    </SlickList>

  </div>
</template>
<script>
import { SlickList, SlickItem } from "vue-slicksort";
export default {
  name: "WsSlickSort",
  props: {
    sortList: {
      type: Array,
      default() {
        return [];
      },
    },
    inputTitle: {
      type: String,
      default: "",
    },
  },
  components: {
    SlickItem,
    SlickList,
  },
  methods: {
    $_afterChange(val) {
      this.$emit("sortList", val);
    },
  },
};
</script>

<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-slick-sort.scss";
</style>